import {Component, createRef} from 'react'
import PropTypes from 'prop-types'
import {AsyncTypeahead} from 'react-bootstrap-typeahead'
import {toastr} from 'react-redux-toastr'

import api from '../../../../../api.js'

import './FilterCity.scss'

export default class FilterCity extends Component {
  static propTypes = {
    city: PropTypes.string,
    className: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    relocation: PropTypes.bool,
  }

  static defaultProps = {
    city: null,
    className: '',
    placeholder: 'Autour de ...',
    relocation: true,
  }

  constructor(props) {
    super(props)
    this.state = {
      options: [],
      selected: props.city !== null ? [{label: props.city}] : [],
    }
    this.typeaheadRef = createRef()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.city !== this.props.city && (this.props.city ?? null) !== (this.selectedCity() ?? null)) {
      this.setState({
        selected: this.props.city !== null ? [{label: this.props.city}] : [],
      })
    }
  }

  selectedCity = () => this.state.selected[0]?.label ?? null

  onChange  = async (value) => {
    this.setState({selected: value})

    if (value.length === 0) {
      this.props.onChange({
        city: null,
        latitude: null,
        longitude: null,
      })
      return
    }

    try {
      const latLng = (await api.cities.getLocation({placeId: value[0].id})).data

      this.props.onChange({
        city: value[0].label,
        latitude: latLng.lat,
        longitude: latLng.lng,
      })
    } catch (e) {
      console.warn(e)
      toastr.error('Une erreur est survenue.')
    }
  }

  onSearch = async (query) => {
    const data = (await api.cities.getAll({keyword: query})).data
    this.setState({options: data})
  }

  onBlur = () => {
    if (this.state.selected.length === 0) {
      this.typeaheadRef.current?.clear()
    }
  }

  onChecked = (event) => {
    this.props.onChecked(event.target.checked)
  }

  render() {
    return <div className="filter-city-form">
      <AsyncTypeahead
        ref={this.typeaheadRef}
        id={`city-typeahead`}
        className="w-100"
        clearButton={true}
        isLoading={!!this.state.loading}
        onBlur={this.onBlur}
        onChange={this.onChange}
        onSearch={this.onSearch}
        options={this.state.options}
        placeholder={this.props.placeholder}
        selected={this.state.selected}
        selectHintOnEnter={true}
      />
      {this.props.isRemote ?
        <div className="mt-1">
          <input type="checkbox" onChange={this.onChecked} checked={this.props.relocation} id="isRelocation"/>
          <label htmlFor="isRelocation">Mobile partout en France</label>
        </div> : ''
      }
    </div>
  }
}
